import { render, staticRenderFns } from "./CoursewareToolbarClipboard.vue?vue&type=template&id=5e4a0efd&"
import script from "./CoursewareToolbarClipboard.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolbarClipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports